<template>
  <b-container id="inscriptions_container">
    <b-row>
      <b-col md="12">
        <div class="content_container">
          <transition name="fade">
            <TableauInscrits></TableauInscrits>
          </transition>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import TableauInscrits from "@/components/Inscriptions_tab/TableauInscritsPaginated.vue";

export default {
  components: { TableauInscrits },
  data() {
    return {
      listCourses: [this.$t("tous_parcours")],
    };
  },
  methods: {
    getListCourses(data) {
      for (var i = 0; i < data.length; i++) {
        if (!this.listCourses.includes(data[i].course)) {
          this.listCourses.push(data[i].course);
        }
      }
    },
    handleEMORCChallenge() {
      // WIP C'est pas beau, à généraliser
      var inscriptions_to_add = [];
      var inscriptions = JSON.parse(JSON.stringify(this.$store.state.module.list_inscriptions));

      for (var i = 0; i < inscriptions.list.length; i++) {
        if (inscriptions.list[i].course === "TRAIL RUNNING 40km + Uphill 10km Master Championship") {
          var new_inscription_1 = JSON.parse(JSON.stringify(inscriptions.list[i]));
          var new_inscription_2 = JSON.parse(JSON.stringify(inscriptions.list[i]));
          new_inscription_1.course = "TRAIL RUNNING 40km Master Championship";
          new_inscription_2.course = "MOUNTAIN RUNNING 10km (Uphill) Master Championship";
          inscriptions_to_add.push(new_inscription_1);
          inscriptions_to_add.push(new_inscription_2);
        }
      }

      var filtered_inscriptions = inscriptions.list.filter((item) => item.course && item.course !== "TRAIL RUNNING 40km + Uphill 10km Master Championship");
      for (var i = 0; i < inscriptions_to_add.length; i++) {
        filtered_inscriptions.push(inscriptions_to_add[i]);
      }

      this.$store.state.module.list_inscriptions.list = filtered_inscriptions;

      this.listCourses = this.listCourses.filter((e) => e !== "TRAIL RUNNING 40km + Uphill 10km Master Championship");
    },
  },
  created() {
    /*  if (!this.$store.state.showParticipantsTab) {
      this.$router.push({ path: "/" + this.$store.state.module.base + "/live" });
    } */
    if (this.$store.state.hide_nb_inscrits) {
      this.$router.push({ name: "Courses" });
    }
    this.$store.commit("setLoading");
    var _this = this;
    axios.get(this.$store.state.base_url + "/inscription/get.php?base=" + this.$store.state.module.base).then(function (response) {
      _this.$store.commit("setInscriptions", response.data);

      _this.getListCourses(response.data);
      if (_this.$store.state.module.base === "EMORC22") {
        _this.handleEMORCChallenge();
      }
      _this.$store.commit("unsetLoading");
      _this.$forceUpdate();
    });
  },
};
</script>

<style lang="sass" scoped>
</style>